import { render, staticRenderFns } from "./CourseLayout.vue?vue&type=template&id=2cfee51e&scoped=true"
import script from "./CourseLayout.vue?vue&type=script&lang=js"
export * from "./CourseLayout.vue?vue&type=script&lang=js"
import style0 from "./CourseLayout.vue?vue&type=style&index=0&id=2cfee51e&prod&lang=css"
import style1 from "./CourseLayout.vue?vue&type=style&index=1&id=2cfee51e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfee51e",
  null
  
)

export default component.exports